<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb></breadcrumb>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                  <div class="row ml-md-3">
                    <div class="col-md-12 mb-2">
                      <!-- <h3 class="mb-3" style="font-weight: bold;font-size:20px;">{{ currentDay }} , {{ todays_date }} </h3> -->
                      <div>
                        <router-link :to="'/doctor/patients'">
                        <button class="new_btn btn btn-sm btn-primary">Book Appointment</button>
                        </router-link>
                        <button data-toggle="modal" @click="
                    $bvModal.show('add_new_patient');
                  " href="" class="new_btn btn btn-sm btn-primary">Add New patient</button>
                      </div>
                      <h4 class="mb-3 mt-5" style="padding-top: 0;">Appointments</h4>
                      <div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget dct-border-rht">
                                <div class="circle-bar circle-bar2">
                                  <div class="progressresult circle-graph3" data-value="100">
                                    <span class="progress-left">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <div class="
                                        progress-value
                                        w-100
                                        h-100
                                        align-items-center
                                        rounded-circle
                                        d-flex
                                        justify-content-center
                                      ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-02.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Today</h6>
                                  <router-link v-if="todays_appointment > 0" :to="'/doctor/appointments'">
                                    <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;">{{ todays_appointment }}</button>
                                  </router-link>
                                  <button class="btn btn-sm btn-secondary" v-else style="border-radius: 100%;">{{ todays_appointment }}</button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget dct-border-rht">
                                <div class="circle-bar circle-bar1">
                                  <div class="progressresult circle-graph3" data-value="75">
                                    <span class="progress-left">
                                      <span class="progress-bar total-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar total-patients"></span>
                                    </span>
                                    <div class="
                                        progress-value
                                        w-100
                                        h-100
                                        align-items-center
                                        rounded-circle
                                        d-flex
                                        justify-content-center
                                      ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-01.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Upcoming</h6>
                                  <router-link v-if="upcoming_appointment > 0" :to="'/doctor/appointments'">
                                    <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;">{{ upcoming_appointment }}</button>
                                  </router-link>
                                  <button class="btn btn-sm btn-secondary" v-else  style="border-radius: 100%;">{{ upcoming_appointment }}</button>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="col-md-12 col-lg-3">
                              <div class="dash-widget dct-border-rht">
                                <div class="circle-bar circle-bar3">
                                  <div class="progressresult circle-graph3" data-value="100">
                                    <span class="progress-left">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <div class="
                                        progress-value
                                        w-100
                                        h-100
                                        align-items-center
                                        rounded-circle
                                        d-flex
                                        justify-content-center
                                      ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-02.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Cancelled</h6>
                                  <router-link v-if="cancelled_appointment > 0" :to="'/doctor/appointments'">
                                    <h3>{{ cancelled_appointment }}</h3>
                                  </router-link>
                                  <h3 v-else>{{ cancelled_appointment }}</h3>
                                </div>
                              </div>
                            </div> -->

                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget">
                                <div class="circle-bar circle-bar4">
                                  <div class="progressresult circle-graph3" data-value="50">
                                    <span class="progress-left">
                                      <span class="progress-bar appointments"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar appointments"></span>
                                    </span>
                                    <div class="
                                        progress-value
                                        w-100
                                        h-100
                                        align-items-center
                                        rounded-circle
                                        d-flex
                                        justify-content-center
                                      ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-03.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Total</h6>
                                  <router-link v-if="appointments > 0" :to="'/doctor/appointments'">
                                    <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;">{{ appointments }}</button>
                                  </router-link>
                                  <button class="btn btn-sm btn-secondary" v-else style="border-radius: 100%;">{{ appointments }}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row ml-md-3">
                    <div class="col-md-12 ">
                      <!-- <h3 class="mb-3" style="font-weight: bold;font-size:20px;">{{ currentDay }} , {{ todays_date }} </h3> -->
                      <h4 class="mb-3 mt-3">Patient Encounters</h4>
                      <div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget dct-border-rht">
                                <div class="circle-bar circle-bar2">
                                  <div class="progressresult circle-graph3" data-value="100">
                                    <span class="progress-left">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <div class="
                                        progress-value
                                        w-100
                                        h-100
                                        align-items-center
                                        rounded-circle
                                        d-flex
                                        justify-content-center
                                      ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-02.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Open</h6>
                                  <router-link v-if="count_open > 0" :to="'/doctor/patient-encounter'">
                                    <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;">{{ count_open }}</button>
                                  </router-link>
                                  <button class="btn btn-sm btn-secondary" v-else style="border-radius: 100%;">{{ count_open }}</button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget dct-border-rht">
                                <div class="circle-bar circle-bar1">
                                  <div class="progressresult circle-graph3" data-value="75">
                                    <span class="progress-left">
                                      <span class="progress-bar total-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar total-patients"></span>
                                    </span>
                                    <div class="
                                        progress-value
                                        w-100
                                        h-100
                                        align-items-center
                                        rounded-circle
                                        d-flex
                                        justify-content-center
                                      ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-01.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Closed</h6>
                                  <router-link v-if="count_closed > 0" :to="'/doctor/patient-encounter'">
                                    <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;">{{ count_closed }}</button>
                                  </router-link>
                                  <button class="btn btn-sm btn-secondary" v-else style="border-radius: 100%;">{{ count_closed }}</button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget dct-border-rht">
                                <div class="circle-bar circle-bar3">
                                  <div class="progressresult circle-graph3" data-value="100">
                                    <span class="progress-left">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <div class="
                                        progress-value
                                        w-100
                                        h-100
                                        align-items-center
                                        rounded-circle
                                        d-flex
                                        justify-content-center
                                      ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-02.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>All</h6>
                                  <router-link v-if="count_all > 0" :to="'/doctor/patient-encounter'">
                                    <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;">{{ count_all }}</button>
                                  </router-link>
                                  <button class="btn btn-sm btn-secondary" v-else style="border-radius: 100%;">{{ count_all }}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row ml-md-3">
                    <div class="col-md-12">
                      <h4 class="mb-3 mt-3">Receipts</h4>
                      <div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget dct-border-rht">
                                <div class="circle-bar circle-bar2">
                                  <div class="progressresult circle-graph3" data-value="100">
                                    <span class="progress-left">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <div class="
                                    progress-value
                                    w-100
                                    h-100
                                    align-items-center
                                    rounded-circle
                                    d-flex
                                    justify-content-center
                                  ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-02.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Today</h6>
                                  <button class="btn btn-sm btn-secondary" style="border-radius: 100%;" v-if="receipt_today_data == 0">
                                    0</button>
                                  <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;" v-else>{{ receipt_today_data === '' ? '0' : '₹' }}
                                    {{ receipt_today_data }}</button>
                                  <!-- <p class="text-muted">{{ todays_date }}</p> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget dct-border-rht">
                                <div class="circle-bar circle-bar1">
                                  <div class="progressresult circle-graph3" data-value="75">
                                    <span class="progress-left">
                                      <span class="progress-bar total-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar total-patients"></span>
                                    </span>
                                    <div class="
                                    progress-value
                                    w-100
                                    h-100
                                    align-items-center
                                    rounded-circle
                                    d-flex
                                    justify-content-center
                                  ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-01.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>This Month</h6>
                                  <button class="btn btn-sm btn-secondary" style="border-radius: 100%;" v-if="receipt_month_data == 0">0</button>
                                  <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;" v-else>{{ receipt_month_data === '' ? '0' : '₹' }}
                                    {{ receipt_month_data }}</button>
                                  <!-- <p class="text-muted">Till Today</p> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 col-lg-4">
                              <div class="dash-widget">
                                <div class="circle-bar circle-bar3">
                                  <div class="progressresult circle-graph3" data-value="100">
                                    <span class="progress-left">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar today-patients"></span>
                                    </span>
                                    <div class="
                                      progress-value
                                      w-100
                                      h-100
                                      align-items-center
                                      rounded-circle
                                      d-flex
                                      justify-content-center
                                    ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-02.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Total</h6>
                                  <button v-if="receipt_total_data == 0" class="btn btn-sm btn-secondary" style="border-radius: 100%;">0</button>
                                  <div class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;" v-else>{{ receipt_total_data === '' ? '0' : '₹' }}
                                    {{ receipt_total_data }}</div>
                                  <!-- <p class="text-muted">{{ todays_date }}</p> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row ml-md-3">
                    <div class="col-md-12">
                      <h4 class="mb-3 mt-3">Total Patients</h4>
                      <div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-12 col-lg-3">
                              <div class="dash-widget">
                                <div class="circle-bar circle-bar4">
                                  <div class="progressresult circle-graph3" data-value="50">
                                    <span class="progress-left">
                                      <span class="progress-bar appointments"></span>
                                    </span>
                                    <span class="progress-right">
                                      <span class="progress-bar appointments"></span>
                                    </span>
                                    <div class="
                                        progress-value
                                        w-100
                                        h-100
                                        align-items-center
                                        rounded-circle
                                        d-flex
                                        justify-content-center
                                      ">
                                      <div class="h2 font-weight-bold">
                                        <img src="@/assets/img/icon-03.png" class="img-fluid" alt="Patient" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="dash-widget-info">
                                  <h6>Total</h6>
                                  <router-link v-if="total_patients > 0" :to="'/doctor/patients'">
                                    <button class="btn btn-sm btn-primary new_btn" style="border-radius: 100%;">{{ total_patients }}</button>
                                  </router-link>
                                  <button class="btn btn-sm btn-secondary" v-else>{{ total_patients }}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
      <div class="modal fade custom-modal show" id="viewappointment">
        <div class="modal-dialog modal-dialog-centered modal-md appointment_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <img src="@/assets/img/logo/Knee_Xpert_Logo_Reverse.svg" alt="logo"
                          class="appointment_modal_logo" />
                      </div>
                    </div>
                    <div class="col-12 col-md-5">
                      <div class="form-group">
                        <label>Patient : </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-7">
                      <div class="form-group">
                        <label>{{ appointments_details.patient_name }}</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-5">
                      <div class="form-group">
                        <label>Age : </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-7">
                      <div class="form-group">
                        <label>{{
                          appointments_details.patient_age
                          ? appointments_details.patient_age
                          : "-"
                        }}</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <label>Doctor : </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-7">
                      <div class="form-group">
                        <label style="margin-left: 50px">{{
                          appointments_details.practitioner_name
                        }}</label><br />
                        <!-- <label class="ml-5">{{
                          appointments_details.service_unit ? appointments_details.service_unit : '-'
                        }}</label> -->
                        <img class="avatar-img rounded-circle adjust-doctor-image" v-bind:src="appointments_details.image
                              ? config.base_url_for_Image +
                              appointments_details.image
                              : loadImg('Patient Profile.svg')
                            " alt="User Image" />
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <b>Appointment Details</b>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Date : </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-9">
                      <div class="form-group">
                        <label>{{
                          appointments_details.appointment_date
                        }}</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Time : </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-9">
                      <div class="form-group">
                        <label>{{
                          appointments_details.appointment_time
                        }}</label>
                      </div>
                    </div>
                    <!-- <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Location : </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-9">
                      <div class="form-group">
                        <label>SAHAJ HOSPITAL</label><br />
                        <label>INDORE</label>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
        <!-- new patient add modal -->
        <div>
      <b-modal id="add_new_patient" hide-footer>
        <!-- <template #modal-title> -->
        <template #modal-title>
          <h3 class="modal-title">Add New Patient</h3>
        </template>
        <div class="d-block text-center">
          <div class="card">
            <div class="card-body">
              <div class="modal-body">
                <div class="row form-row" v-if="!showOtpInput">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input type="text" name="first_name" required class="form-control floating"
                        v-model="register_patient.first_name" placeholder="First Name"
                        oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input type="text" name="last_name" required class="form-control floating"
                        v-model="register_patient.last_name" placeholder="Last Name"
                        oninput="this.value = this.value.replace(/[^a-zA-Z]/g, '');" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group" style="position: relative;">
                      <button class="btn btn-default" type="button"
                        style="position: absolute; left: 0; top: 0; border: 1px solid #ccc; border-right: none; background-color: lightgrey; height: 40px; border-radius: 4px 0 0 4px; z-index: 2;">+91</button>
                      <input type="text" required maxlength="10" minlength="10" @keypress="onlyNumber"
                        v-model="register_patient.patient_mobile_no" class="form-control floating"
                        placeholder="Mobile Number" @keydown.enter.prevent="$refs.sendOtpButton.click()"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        style="padding-left: 60px; padding-top: 10px; padding-bottom: 10px; border-radius: 4px; letter-spacing: 2px;" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <v-select name="city" required="" label="city" placeholder="Select City"
                        v-model="register_patient.city" :reduce="(option) => option.city" :options="cities">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="text-center mt-2">
                      <div class="submit-section text-left">
                        <button type="submit" id="medical_btn" class="btn btn-primary submit-btn" data-dismiss="modal"
                          aria-label="Close" @click="New_Patient_add()">
                          Send OTP
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="col-md-12 col-lg-12">
                  <div class="login-header">
                    <h3 class="text-center">Enter OTP</h3>
                    <!-- <p class="small text-muted">Enter your OTP No</p> -->
                  </div>

                  <!-- Forgot Password Form -->
                  <div id="app">
                    <div class="otp-container">
                      <input v-for="(value, index) in otpValues" :key="index" type="text" maxlength="1" class="otp-input"
                        :value="value" @input="handleInput(index, $event.target.value)"
                        @keydown.backspace="handleBackspace(index)" ref="otpFields" @keypress="onlyNumber"
                        @keydown.enter.prevent="verify_OTP()" pattern="[0-9]*" autofocus />
                    </div>
                  </div>
                  <div class="mt-5">
                    <button ref="verifyOtpButton" class="btn btn-primary login-btn" type="submit" @click="verify_OTP()">
                      Verify OTP
                    </button>
                  </div>
                  <!-- /Forgot Password Form -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- new patient add modal end -->
  </div>
</template>

<script>
import CommonApi from "@/services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");
const doctorimages = require.context("@/assets/img/doctors");
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";

export default {

  data() {
    return {
      otpValues: ["", "", "", "", "", ""],
      cities: [],
      total_patients:0,
      upcoming_appointment: 0,
      todays_date: new Date()
        .toString()
        .split(" ")
        .splice(1, 3)
        .join(" "),
      config: config,
      upcoming_appointment: "",
      todays_appointment: "",
      cancelled_appointment: "",
      appointments: "",
      count_all: "",
      count_open: "",
      count_closed: "",
      receipt_today_data: "",
      receipt_month_data: "",
      receipt_total_data: "",
      showspinner: true,
      appointments_details: {
        patient_name: "",
        practitioner_name: "",
        appointment_date: "",
        appointment_time: "",
        service_unit: "",
        image: "",
        patient_age: "",
      },
      register_patient: {
        doctor_mobile_no: "",
        first_name: "",
        last_name: "",
        patient_mobile_no: "",
        city: null,
      },
      showOtpInput: false,
    };
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }

    this.User();
    this.get_doctor_details()
    this.my_patients();
    this.get_patient_appointment_count_cancel(),
      this.get_patient_appointment_count_upcoming(),
      this.get_patient_appointment_count_today(),
      this.get_patient_appointment_count_all(),
      this.get_patient_encounter_count_all();
    this.get_patient_encounter_count_open();
    this.get_patient_encounter_count_closed();
    this.get_receipt_data();
    this.get_cities();
    $(".progressresult").each(function () {
      const percentageToDegrees = (percentage) => {
        return (percentage / 100) * 360;
      };
      let value = $(this).attr("data-value");
      let left = $(this).find(".progress-left .progress-bar");
      let right = $(this).find(".progress-right .progress-bar");

      if (value > 0) {
        if (value <= 50) {
          right.css(
            "transform",
            "rotate(" + percentageToDegrees(value) + "deg)"
          );
        } else {
          right.css("transform", "rotate(180deg)");
          left.css(
            "transform",
            "rotate(" + percentageToDegrees(value - 50) + "deg)"
          );
        }
      }
    });
  },
  computed: {
    isOtpValid() {
      return this.otp.every((digit) => /\d/.test(digit)); // Check if all digits are numbers
    },
    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,
    }),
  },

  methods: {

    handleInput(index, value) {
      if (value.length > 1) {
        return;
      }
      this.otpValues[index] = value;
      if (value.length === 1 && index < this.otpValues.length - 1) {
        this.$refs.otpFields[index + 1].focus();
      }
    },
    handleBackspace(index) {
      if (this.otpValues[index] !== "") {
        this.otpValues[index] = "";
      } else if (index > 0) {
        this.$refs.otpFields[index - 1].focus();
      }
    },


    async get_cities() {
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.cities = res.message;
        console.log(this.cities);
      });
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    async New_Patient_add() {
      if (this.register_patient) {
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.register_patient.patient_mobile_no);
        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (res.status_code == 200) {
              this.showOtpInput = true;
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
              });
              setTimeout(() => {
                this.$swal.close();
              }, 1000);
            } else {
              this.$swal.fire({
                icon: "warning",
                title: "Warning",
                text: res.message,
                showConfirmButton: true,
              });
            }
          }
        );
      }
    },

    verify_OTP() {
      const fullOtp = this.otpValues.join("");
      if (this.register_patient.patient_mobile_no && fullOtp) {
        this.$swal({
          text: "Verifying OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.register_patient.patient_mobile_no);
        bodyFormData.append("otp", fullOtp);

        CommonApi.post_data("sahaj.api.verify_otp_code", bodyFormData, true).then((res) => {
          if (res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
            });
            this.register_New_Patient();
          } else {
            // OTP verification failed
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      }
    },

    register_New_Patient() {
      this.$swal({
        text: "Creating your account",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      let data = {
        doctor_mobile_no: this.register_patient.doctor_mobile_no,
        first_name: this.register_patient.first_name,
        last_name: this.register_patient.last_name,
        patient_mobile_no: this.register_patient.patient_mobile_no,
        city: this.register_patient.city,
      };

      CommonApi.post_data("sahaj.doctor_bot.register_patient_by_doctor_bot", data, true).then((res) => {
        if (res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            this.$router.push(`/doctor/patients`);
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    get_doctor_details() {
      const params = new URLSearchParams();
      params.append("name", this.user_id);
      CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code === 200) {
          this.register_patient.doctor_mobile_no = res.data.mobile_phone;
        }
      });
    },

    async my_patients() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data("sahaj.api.my_patients", params).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.total_patients = res.data.length;
        }
      });
    },

    User() {
      if (this.user_type !== "doctor") {
        this.$router.push("/patient/index");
      }
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    loadDoctorImg(imgPath) {
      return doctorimages("./" + imgPath);
    },

    /* Get Total Appointment  Data */
    get_patient_appointment_count_upcoming() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_count_upcoming",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.upcoming_appointment = res.data[0].count;
        }
      });
    },

    /* Get Today Appointment  Data */
    get_patient_appointment_count_today() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_count_today",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.todays_appointment = res.data[0].count;
        }
      });
    },

    /* Get Cancelled Appointment  Data */
    get_patient_appointment_count_cancel() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_count_cancelled",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.cancelled_appointment = res.data[0].count;
        }
      });
    },

    /* Get Closed counts */
    get_patient_encounter_count_closed() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_patient_encounter_count_closed",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.count_closed = res.data;
        }
      });
    },

    /* Get Appointments  Data */
    get_patient_appointment_count_all() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_count_all",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.appointments = res.data;
        }
      });
    },

    /* Get All counts */
    get_patient_encounter_count_all() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_patient_encounter_count_all",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.count_all = res.data;
        }
      });
    },

    /* Get Open counts */
    get_patient_encounter_count_open() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_patient_encounter_count_open",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.count_open = res.data;
        }
      });
    },

    /* Get Receipt all Info */
    get_receipt_data() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_receipts_amount",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.receipt_today_data = res.data.today;
          this.receipt_month_data = res.data.this_month;
          this.receipt_total_data = res.data.total;
        }
      });
    },

    /* Get Date */
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        return [day, mnth, date.getFullYear()].join("-");
      }
    },
    convertTime(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          time =
            ("00" + date.getHours()).slice(-2) +
            ":" +
            ("00" + date.getMinutes()).slice(-2) +
            ":" +
            ("00" + date.getSeconds()).slice(-2);
        var H = +time.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = H < 12 ? " AM" : " PM";
        var timeString = h + time.substr(2, 3) + ampm;
        return timeString;
      }
    },
  },
};
</script>

<style scoped>
.time-slots .display-time {
  width: 150px !important;
}

.time-slots .clear-btn {
  display: none !important;
}
.disabled-btn {
  background-color: #DCDCDC;
  cursor: not-allowed;
  pointer-events: none;
  border: #DCDCDC;
}

.new_btn:hover{
  background-color: #2E8B57;
}


@media screen and (min-width: 1024px) {

  .dash-widget-info {
    text-align: center;
  }
}
.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  margin: 0 10px;
  border: none;
  border-bottom: 2px solid #403636;
  box-shadow: none;
  background-color: transparent;
  color: #140b0b;
  transition: all 0.3s ease-in-out;
  font-family: Arial, Helvetica, sans-serif;
}
.otp-input:focus {
  outline: none;
  border-bottom: 2px solid #09e5ab;
}

</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Index.vue